const configStore = {
    store: {
        listLayout: 'StoreListLayout',
        filterLayout: 'StoreFilterLayout',
        paginationLayout: 'PaginationDefaultLayout',

        getFunc: 'getStore',
        listApiParamSet: {
            ip: 1,
            sp:10
        }
    },
    storeTrade: {
        listLayout: 'StoreTradeListLayout',
        filterLayout: 'StoreTradeFilterLayout',
        paginationLayout: 'PaginationDefaultLayout',

        getFunc: 'getStoreTrade',
        listApiParamSet: {
            ip: 1,
            sp:10
        }
    },
}

export default {
    methods: {
        returnStoreConfig(type) {
            return configStore[type];
        }
    },
    filterConfig: {
        cr: { // 교환일
            type: 'between',
            classname: 'filterDate'
        },
        prsd : { //가격시작
            type : 'match',
            classname : 'filterPrice_prsd'
        },
        pred : { //가격 끝
            type : 'match',
            classname : 'filterPrice_pred'
        },
        bn: { //교환처(상품 목록)
            type: 'query',
            classname: 'searchInput',
        },
        gn: { //상품권명
            type: 'query',
            classname: 'searchInput',
        },
        br: { //교환처(교환 내역)
            type: 'query',
            classname: 'searchInput',
        },
        mid: { // 유저 아이디
            type: 'query',
            classname: 'searchInput',
        },
    }
}